export default {
  getDefaultState: () => {
    return {
      logs: [],
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      isCallingLogs: false
    }
  }
}
